/**
 * グローバルメニューのレスポンシブ用JS
 */

jQuery(function($) {

  $(function () {
    $('.zdo_drawer_button').click(function () {
      $(this).toggleClass('active');
      $('.zdo_drawer_bg').fadeToggle();
      $('nav').toggleClass('open');
    })
    $('.zdo_drawer_bg').click(function () {
      $(this).fadeOut();
      $('.zdo_drawer_button').removeClass('active');
      $('nav').removeClass('open');
    });
  })

  $(function(){
    $(".accordion li a").on("click", function() {
      $(this).next().slideToggle();
      // activeが存在する場合
      if ($(this).children(".accordion_icon").hasClass('active')) {
        // activeを削除
        $(this).children(".accordion_icon").removeClass('active');
      }
      else {
        // activeを追加
        $(this).children(".accordion_icon").addClass('active');
      }
    });
  });

  // PC - ドロップメニュー
	if (window.matchMedia('(min-width: 993px)').matches) {
		$('.primary-menu').children('.menu-item').hover(function(){
			$(this).addClass('active');
			$("ul:not(:animated)",this).fadeIn(500); //アニメーションの途中にアニメーションを実行しない
		}, function(){
			$(this).removeClass('active');
			$("ul.sub-menu",this).fadeOut(300);
		});
	}
});
